import React, { createContext, useState, useEffect, useContext, useRef } from 'react';
import { io } from 'socket.io-client';
import { Alert } from 'react-native';
import { initDB, syncFiyatlar, getFiyatlar, syncPersonel, getPersonel } from '../services/Database';

const VehicleContext = createContext();

// Sabit Sözlükler (Görselleştirme için)
export const KATEGORILER = {
  1: "Otomobil",
  2: "SUV / Jeep",
  3: "Ticari",
  4: "Motosiklet",
  5: "Minibüs"
};

export const HIZMETLER = {
  1: "İç-Dış Yıkama",
  2: "Dış Yıkama",
  3: "Detaylı Temizlik",
  4: "Motor Yıkama",
  5: "Hızlı Cila"
};

export const VehicleProvider = ({ children }) => {
  const [vehicles, setVehicles] = useState([]);
  const [fiyatListesi, setFiyatListesi] = useState([]);
  const [personelListesi, setPersonelListesi] = useState([]);
  const [isConnected, setIsConnected] = useState(false);

  const [nakitToplam, setNakitToplam] = useState(0);
  const [kartToplam, setKartToplam] = useState(0);
  
  const socketRef = useRef(null);

  // 1. Yeni state ekle (nakitToplam/kartToplam yanına)
const [personelOzetleri, setPersonelOzetleri] = useState({});



// 3. Provider value'ya ekle
// personelOzetleri, ekle

  // 1. API'den Verileri Çek ve SQLite'a Kaydet
  const veritabaniniGuncelle = async () => {
    try {
      console.log("🌐 API Güncellemesi Başladı...");
      
      // Fiyatları Çek
      const resFiyat = await fetch('https://mirwax.durumrapor.com/app.php?action=Fiyatlar');
      const dataFiyat = await resFiyat.json();
      if (dataFiyat && Array.isArray(dataFiyat)) {
        await syncFiyatlar(dataFiyat);
        setFiyatListesi(await getFiyatlar());
      }

      // Personeli Çek
      const resPersonel = await fetch('https://mirwax.durumrapor.com/app.php?action=Personel');
      const dataPersonel = await resPersonel.json();
      if (dataPersonel && Array.isArray(dataPersonel)) {
        await syncPersonel(dataPersonel);
        setPersonelListesi(await getPersonel());
      }
    } catch (error) {
      console.log("⚠️ API Hatası (Yerel veriler yükleniyor):", error);
      setFiyatListesi(await getFiyatlar());
      setPersonelListesi(await getPersonel());
    }
  };

  // 2. Socket üzerinden Araç Listesini İste
  const verileriYenile = () => {
    if (socketRef.current && socketRef.current.connected) {
      console.log("🔄 Socket: Araç listesi isteniyor...");
      socketRef.current.emit("get_client_list");
      socketRef.current.emit("senk", { message: "Rapor" });
    }
  };

  useEffect(() => {
    // İlk Kurulum
    const setup = async () => {
      await initDB();
      await veritabaniniGuncelle();
    };
    setup();

    // Socket Bağlantısı
    socketRef.current = io("https://socket.durumrapor.com", {
      transports: ['websocket'],
    });

    socketRef.current.on("connect", () => {
      setIsConnected(true);
      console.log("✅ Socket Bağlandı");
      verileriYenile();
    });

    socketRef.current.on("disconnect", () => {
      setIsConnected(false);
      console.log("❌ Socket Ayrıldı");
    });

    

socketRef.current.on("senk", (data) => {
      try {
        const rawString = data?.data?.veri;
        if (!rawString) return;

        const tumVeriler = JSON.parse(rawString);
        const bugun = new Date().toISOString().slice(0, 10);

        // Filtreleme: Aktif olanlar veya bugün işlem görenler
        const filtreliVeri = tumVeriler.filter((kayit) => {
          const girisTarih = kayit.Giris ? kayit.Giris.slice(0, 10) : null;
          return kayit.Status === 1 || girisTarih === bugun;
        });

        // HomeScreen formatına dönüştürme
        const formatliVeri = filtreliVeri.map((item) => ({
          id: item.ID.toString(),
          plate: item.Plaka,
          personnel: item.Eleman || "Bilinmiyor",
          category: KATEGORILER[item.Kategori] || "Diğer",
          categoryId: item.Kategori,
          service: HIZMETLER[item.Hizmet] || "Standart",
          serviceId: item.Hizmet,
          date: item.Giris,
          isPaid: item.Status === 2 ,
          RemoteTahsilat: item.RemoteTahsilat,
          OdemeTuru: item.OdemeTuru
        }));

        // --- YENİ EKLENEN ASENKRON HESAPLAMA BÖLÜMÜ ---
// 2. toplamlariHesapla fonksiyonunu güncelle
const toplamlariHesapla = async (aracListesi) => {

  let hesaplananNakit = 0;
  let hesaplananKart = 0;
  const personelMap = {}; // YENİ

  await Promise.all(aracListesi.map(async (item) => {
    let check = item.RemoteTahsilat || '';

    if (check === 'OK') {
      let tutar = 0;

      try {
        const response = await fetch("https://mirwax.durumrapor.com/app.php?action=GetPrice", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        });
        const data = await response.json();
        tutar = parseFloat(data?.price) || 0;
      } catch (error) {
        console.log(`Fiyat çekilemedi (Plaka: ${item.plate}):`, error);
      }

      // Genel toplamlar (mevcut)
      if (item.OdemeTuru === 'NAKİT') {
        hesaplananNakit += tutar;
      } else if (item.OdemeTuru === 'KREDİ KARTI') {
        hesaplananKart += tutar;
      }

      // YENİ: Personel bazında grupla
      const personel = item.personnel || 'Bilinmiyor';
      if (!personelMap[personel]) {
        personelMap[personel] = { nakit: 0, kart: 0 };
      }
      if (item.OdemeTuru === 'NAKİT') {
        personelMap[personel].nakit += tutar;
      } else if (item.OdemeTuru === 'KREDİ KARTI') {
        personelMap[personel].kart += tutar;
      }
    }
  }));

  setNakitToplam(hesaplananNakit);
  setKartToplam(hesaplananKart);
  setPersonelOzetleri(personelMap); // YENİ
};
        // Fonksiyonu çalıştırıyoruz
        toplamlariHesapla(formatliVeri);
        
        // Listeyi ekrana basıyoruz
        setVehicles(formatliVeri.reverse());

      } catch (e) {
        console.log("🚨 Socket Veri İşleme Hatası:", e);
      }
    });

    return () => {
      if (socketRef.current) socketRef.current.disconnect();
    };
  }, []);

  return (
    <VehicleContext.Provider value={{ 
      vehicles, 
      fiyatListesi, 
      personelListesi, 
      isConnected, 
      verileriYenile, 
      veritabaniniGuncelle,
      socketRef, // AddScreen'in mesaj göndermesi için gerekli
      nakitToplam,
      kartToplam,
      personelOzetleri
    }}>
      {children}
    </VehicleContext.Provider>
  );
};

export const useVehicles = () => useContext(VehicleContext);